import Task from "../task";
import {toMomentDate} from "../../../gd/convert/moment-date";

export default function taskUpdateEndDate(task:Task, endDate:Moment|null) {


    task.endDate = toMomentDate(endDate)

    // if we set start date to null, end date should be null too
    if (endDate === null) {
        task.startDate = null
    }

    if (task.endDate && !task.startDate) {
        task.startDate = toMomentDate(task.endDate)
    }

    // if endDate BEFORE start set start = end because we update START here
    if (task.endDate && task.startDate && task.endDate.isBefore(task.startDate,'days')) {
        task.startDate = toMomentDate(task.endDate)
    }

    // schedule
    task.autoUpdateScheduleDate()

}